var mobileApiAddress = 'https://ptgweb.pretor.co.za/api/v1/';
var pretorOnlineUrl = 'https://online.pretor.co.za/';
var authenticationAPIAddress = 'https://ptgweb.pretor.co.za/auth/api/v1/';
var pretorDocumentsServerUrl = 'https://ptgwebstorage.pretor.co.za/prod';
var PretorCDNAddress = 'https://ptgweblivestaging.pretor.co.za:444/';
var pretorInternalUrl = 'http://192.22.208.227/';

//replace ends here
//DO NOT DELETE THE ABOVE COMMENT - ITS BEING USED BY THE BUILD STEP!!!

import 'moment';
import 'bootstrap';
require('jquery-ui');
import _ from 'lodash';
import 'angular-animate';
require('jquery-number');
import 'angular-sanitize';
const $ = require('jquery');
import angular from 'angular';

import './app-core';
import './modules/views-module';
import './modules/filters-module';
import './modules/services-module';
import './modules/directives-module';
import './modules/controllers-module';

require('angular-files-drop');

import { FEATURES } from './common';
import { applyMobileNavyTheme } from './common/mobile-navy-theme';

$(() => {
	localStorage.setItem('mobileApiAddress', mobileApiAddress);
});

export default angular
	.module('pretor.online.app', [
		'angular-files-drop',
		'pretor.online.core',
		'pretor.online.views',
		'pretor.online.filters',
		'pretor.online.factories',
		'pretor.online.directives',
		'pretor.online.controllers'
	])
	.config(($httpProvider, $sceDelegateProvider) => {
		$sceDelegateProvider.resourceUrlWhitelist([ 'self', '*' ]);
		$httpProvider.interceptors.push('AuthInterceptorService');
	})
	.run(($state, $timeout, $window, $transitions, $location, $rootScope, NavigationService, LocalStorageService) => {
		applyMobileNavyTheme();
		$rootScope.$on('$locationChangeSuccess', (evt, newNav, oldNav) => {
			
		});

		$transitions.onBefore({}, (transition) => {
			const to = transition.to().name;

			if (to === FEATURES.SET_PASSWORD || to === FEATURES.LOGIN) {
				return true;
			}

			if (NavigationService.requiresPasswordSetup()) {
				return transition.router.stateService.target(FEATURES.SET_PASSWORD);
			}

			return true;
		});
	});
